import { SuperAdminConstants } from '../../../_constants';

const initialState = { editFocusAreaTextLoading: true, data: '', error: false };

export function editFocusAreaTextReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_EDIT_FOCUS_AREA_TEXT:
            return {
                editFocusAreaTextLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_EDIT_FOCUS_AREA_TEXT:
            return {
                editFocusAreaTextLoading: false,
                data: action.editFocusAreaText,
                error: false
            };
        case SuperAdminConstants.EDIT_FOCUS_AREA_TEXT_ERROR:
            return {
                editFocusAreaTextLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/FocusAreaText/editFocusAreaText.reducer.js